import { Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useFcNavigate } from "~/hooks/useFcNavigate";

import { selectIsUserLoggedIn } from "~/redux/selectors/authSelectors";

import { useAppSelector } from "./store";

const PageNotFound = () => {
  const { t } = useTranslation();
  const navigate = useFcNavigate();
  const isUserLoggedIn = useAppSelector(selectIsUserLoggedIn);
  const loginPath =
    useAppSelector((state) => state.app.siteLoginPath) || "/login";

  const handleGoHome = () => {
    navigate(isUserLoggedIn ? "/" : loginPath, { replace: true });
  };

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={4}
      sx={{
        height: "100vh",
        textAlign: "center",
        bgcolor: "background.default",
        px: 3
      }}
    >
      <Typography variant="h2" color="text.primary">
        404
      </Typography>
      <Typography variant="h5" color="text.secondary">
        {t("page not found")}
      </Typography>

      <Button variant="contained" color="primary" onClick={handleGoHome}>
        {isUserLoggedIn ? t("go to home") : t("login")}
      </Button>
    </Stack>
  );
};

export default PageNotFound;
